import { useRef, useState } from "react";
import { Form } from "./Form";
import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModal {
    singleData: {},
    open: boolean
}

export const QualityControle = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false });
    };
    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} reload={reload} setReload={setReload} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}